import ProductCard from '../components/ProductCard';
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import ProductShowcase from '../components/ProductShowcase';
import Citation1 from '../components/Citation1';
import About from '../components/About';
import Navbar from '../components/Navbar';
import Bandeau from '../components/Bandeau';
import React from 'react';


const Produits = [
  { key:"1", nom: "Parfum A", prix: "100$", image: "imageA.jpg" },
  { key:"2", nom: "Parfum B", prix: "120$", image: "imageB.jpg" },
  { key:"3", nom: "Parfum C", prix: "150$", image: "imageC.jpg" },
];

function Home() {
  return (
    <div>
      <Bandeau />
      <Navbar />
      <Hero />
      <ProductShowcase />
      <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
        {Produits.map((produit, index) => (
          <ProductCard 
            key={index} 
            nom={produit.nom} 
            prix={produit.prix} 
            image={produit.image} 
          />
        ))}
      </div>
      <About />
      < Citation1 />
      <Footer />
    </div>
  );
}
export default Home;